import { useLayoutEffect, useMemo } from "react"
import { getItem } from "./api"
import useFetchItemById from "../../../../../../queries/useFetchItemById"

export default function useUploadDocumentResources({id, method = 'view'}){

    const {
        data: invoiceData,
        fetchData: fetchInvoiceData,
        isLoading: isFetchingInvoice,
    } = useFetchItemById({ fetcher:  getItem, moduleName: method })

    const isLoadingResources = useMemo(() => {
        return isFetchingInvoice === true
    }, [
        isFetchingInvoice
    ])

    useLayoutEffect(()=>{fetchInvoiceData({id: id})}, [fetchInvoiceData])

    return {
        id,
        invoiceData, isFetchingInvoice,
        fetchInvoiceData,

        isLoadingResources
    }
}